import apiClient from "../../utils/api.client";
import { getNoaId } from "../../utils/session.utils";

const serviceName = "/delivery-service/api";

/**
 * Obtener estadísticas del dashboard para operadores
 */
const getStatistics = async (organizationId) => {
  try {
    const orgId = organizationId || getNoaId();
    const url = `${serviceName}/agency-orders/statistics?organizationId=${orgId}`;
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    console.error("Error at getStatistics EP: ", error);
    throw error;
  }
};

/**
 * Crear un nuevo pedido (Agencia)
 */
const createAgencyOrder = async (agencyId, payload) => {
  try {
    const url = `${serviceName}/agency-orders/agencies/${agencyId}/orders`;
    const response = await apiClient.post(url, payload);
    return response.data;
  } catch (error) {
    console.error("Error at createAgencyOrder EP: ", error);
    throw error;
  }
};

/**
 * Listar pedidos de una agencia
 */
const getAgencyOrders = async (agencyId, status, page = 0, size = 20) => {
  try {
    let url = `${serviceName}/agency-orders/agencies/${agencyId}/orders?page=${page}&size=${size}`;
    if (status) {
      url += `&status=${status}`;
    }
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    console.error("Error at getAgencyOrders EP: ", error);
    throw error;
  }
};

/**
 * Listar pedidos pendientes (Operador)
 */
const getPendingOrders = async (organizationId, page = 0, size = 20) => {
  try {
    const orgId = organizationId || getNoaId();
    const url = `${serviceName}/agency-orders/pending?organizationId=${orgId}&page=${page}&size=${size}`;
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    console.error("Error at getPendingOrders EP: ", error);
    throw error;
  }
};

/**
 * Obtener detalle de un pedido
 */
const getOrderById = async (orderId) => {
  try {
    const url = `${serviceName}/agency-orders/${orderId}`;
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    console.error("Error at getOrderById EP: ", error);
    throw error;
  }
};

/**
 * Obtener stock disponible para un pedido
 */
const getOrderStockDetails = async (orderId) => {
  try {
    const url = `${serviceName}/agency-orders/${orderId}/stock-details`;
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    console.error("Error at getOrderStockDetails EP: ", error);
    throw error;
  }
};

/**
 * Aprobar un pedido
 */
const approveOrder = async (orderId, payload) => {
  try {
    const url = `${serviceName}/agency-orders/${orderId}/approve`;
    console.log("🔍 [AgencyOrdersService] URL completa:", url);
    console.log("🔍 [AgencyOrdersService] Payload:", JSON.stringify(payload, null, 2));
    const response = await apiClient.put(url, payload);
    console.log("✅ [AgencyOrdersService] Respuesta exitosa:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ [AgencyOrdersService] Error at approveOrder EP:", error);
    console.error("❌ [AgencyOrdersService] Error response:", error.response);
    throw error;
  }
};

/**
 * Rechazar un pedido
 */
const rejectOrder = async (orderId, payload) => {
  try {
    const url = `${serviceName}/agency-orders/${orderId}/reject`;
    const response = await apiClient.put(url, payload);
    return response.data;
  } catch (error) {
    console.error("Error at rejectOrder EP: ", error);
    throw error;
  }
};

const agencyOrdersService = {
  getStatistics,
  createAgencyOrder,
  getAgencyOrders,
  getPendingOrders,
  getOrderById,
  getOrderStockDetails,
  approveOrder,
  rejectOrder,
};

export default agencyOrdersService;

